/** @jsxImportSource @emotion/react */
import star from 'components/landing/images/star.svg';
import { colors, HeadingH3, Text } from 'components/landing/ui';

const Slide = ({ idx, active, hideShadow, reviews }) => {
  const { avatar, name, rating, about } = reviews[idx];

  return (
    <div
      css={{
        cursor: 'pointer',
        padding: 30,
        flexDirection: 'column',
        background: active ? colors.blue : '#fff',
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: 4,
        borderColor: active ? colors.blue : '#000',
        boxShadow: active && !hideShadow ? ' -42px 39px 14px rgba(117, 117, 117, 0.25)' : 'none',
        width: '100%',
        transition: '.5s',
      }}
    >
      <div
        css={{
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: 'row',
          marginBottom: 20,
          flexWrap: 'wrap',
        }}
      >
        <div css={{ alignItems: 'center', flexGrow: 1 }}>
          <div
            css={{
              width: 60,
              height: 60,
              borderRadius: 4,
              marginRight: 15,
              backgroundImage: `url(${avatar})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'cover',
            }}
          />
          <HeadingH3 css={{ color: active ? '#fff' : colors.black, wordBreak: 'keep-all' }}>
            {name}
          </HeadingH3>
        </div>
        <div css={{ marginTop: 10, marginBottom: 10 }}>
          {[...Array(rating)].map((e, i) => (
            <img key={i} src={star} />
          ))}
        </div>
      </div>

      <Text
        css={{
          color: active ? '#fff' : colors.grayLight,
          whiteSpace: 'pre-line',
          wordBreak: 'break-word',
        }}
      >
        {about}
      </Text>
    </div>
  );
};

export default Slide;
